import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: { EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

const urls = {
  getAdvertising: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/content/widget/advertising`
};
export const getAdvertising = params => aHttp.get(urls.getAdvertising, params);
